export default __webpack_public_path__ + "static/media/Gwent-Mod2-InCourseWorkbook.b40bcebd.pdf";